<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.notice', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        

       <p style="font: Calibri; font-size: 22px; font-weight: bold; text-transform:uppercase">{{$t('message.aside.notice', { value: 'default' })}}</p>

       <div style="font: Calibri; font-size: 20px; text-align:justify">
           <p>{{$t('message.pageNotice.second', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.third', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.fourty', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.fifty', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.sixty', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.seventy', { value: 'default' })}}</p>
           <p>{{$t('message.pageNotice.eighty', { value: 'default' })}}</p>
       </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";

export default {
  name: "NoticePage",
  title: "Term of use",

  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
  }
};
</script>

<style scoped>


</style>
